export function calculateFlexBasis(fieldWidthMultiplier: number = 1, totalColumns: number = 6.5): string {
  const BASE_COLUMN_PERCENT = 100 / totalColumns;
  const widthPercent = BASE_COLUMN_PERCENT * fieldWidthMultiplier;
  return `${widthPercent}%`;
}


export function getColSpan(width: number, gridSize: number = 6): number {
  const w = width || 1;
  // Calculate column span based on grid size
  // If gridSize is 6, a width of 1 should span 1 column, width of 2 should span 2 columns, etc.
  // The multiplier adjusts based on grid size (for 6 columns, use 1x multiplier; for 12 columns, use 2x)
  const multiplier = gridSize === 6 ? 1 : (gridSize / 6);
  return Math.min(gridSize, Math.max(1, Math.round(w * multiplier)));
}